module.exports = __webpack_public_path__ + "media/unipod/eight_step2-c8255a03.png";